import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';
import Login from '../components/Login';

const Shell = styled.div`min-height:100vh;background:${p=>p.theme.bg};color:${p=>p.theme.text};`;
const Header = styled.header`height:68px;background:${p=>p.theme.bgCard};border-bottom:1px solid ${p=>p.theme.border};display:flex;align-items:center;justify-content:space-between;padding:0 30px;box-sizing:border-box;`;
const Brand = styled.div`font-size:22px;font-weight:800;letter-spacing:-.5px; span{color:${p=>p.theme.accent};}`;
const Back = styled.a`color:${p=>p.theme.textSecondary};text-decoration:none;font-size:14px;font-weight:600;`;
const Layout = styled.main`max-width:1320px;margin:0 auto;padding:28px;display:grid;grid-template-columns:340px 1fr;gap:22px;box-sizing:border-box;@media(max-width:850px){grid-template-columns:1fr;padding:14px;}`;
const Panel = styled.section`background:${p=>p.theme.bgCard};border:1px solid ${p=>p.theme.border};border-radius:16px;overflow:hidden;box-shadow:${p=>p.theme.shadowCard};`;
const PanelTitle = styled.div`padding:20px 22px;border-bottom:1px solid ${p=>p.theme.border};font-size:18px;font-weight:800;`;
const QuoteRow = styled.button`width:100%;border:0;border-bottom:1px solid ${p=>p.theme.border};background:${p=>p.$active?p.theme.bgHover:'transparent'};padding:17px 20px;text-align:left;color:${p=>p.theme.text};cursor:pointer;border-left:4px solid ${p=>p.$active?p.theme.accent:'transparent'};`;
const RowTitle = styled.div`font-weight:750;margin-bottom:7px;`;
const Muted = styled.div`font-size:13px;color:${p=>p.theme.textSecondary};display:flex;justify-content:space-between;gap:10px;`;
const Detail = styled.div`padding:26px;`;
const Hero = styled.div`display:flex;justify-content:space-between;gap:20px;padding-bottom:22px;border-bottom:1px solid ${p=>p.theme.border};`;
const H1 = styled.h1`font-size:25px;margin:0 0 9px;letter-spacing:-.7px;`;
const Badge = styled.span`align-self:flex-start;background:#e8f7ef;color:#16794a;border-radius:999px;padding:7px 12px;font-size:12px;font-weight:800;`;
const ItemsHead = styled.div`display:flex;justify-content:space-between;align-items:center;margin:24px 0 12px;font-weight:800;`;
const Count = styled.span`color:${p=>p.theme.accent};font-size:14px;`;
const Item = styled.div`display:grid;grid-template-columns:34px 1fr auto;gap:12px;align-items:center;padding:15px 14px;border:1px solid ${p=>p.theme.border};border-radius:12px;margin-bottom:9px;background:${p=>p.theme.bg};`;
const Check = styled.div`width:24px;height:24px;border-radius:7px;background:${p=>p.theme.accent};color:white;display:grid;place-items:center;font-weight:900;`;
const ItemName = styled.div`font-size:15px;font-weight:750;small{display:block;margin-top:5px;color:${p=>p.theme.textSecondary};font-weight:400;}`;
const Price = styled.div`font-weight:800;text-align:right;font-size:14px;`;
const Totals = styled.div`margin:22px 0 0 auto;max-width:370px;padding:18px;border-radius:14px;background:${p=>p.theme.bg};border:1px solid ${p=>p.theme.border};div{display:flex;justify-content:space-between;margin:8px 0;}strong{font-size:20px;color:${p=>p.theme.accent};}`;
const State = styled.div`padding:60px;text-align:center;color:${p=>p.theme.textSecondary};`;

const money = value => `${Number(value || 0).toLocaleString('ko-KR')}원`;
const detailId = () => Number(window.location.pathname.match(/\/quotations\/(\d+)/)?.[1] || 0);

export default function SavedQuotations() {
  const { isLoggedIn, isLoading } = useAuth();
  const [quotes, setQuotes] = useState([]);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState('');

  const openQuote = async id => {
    const response = await fetch(`/api/quotations/${id}`, { credentials: 'include' });
    if (!response.ok) throw new Error('견적서를 불러오지 못했습니다.');
    const data = await response.json();
    setSelected(data.quotation);
    window.history.replaceState(null, '', `/quotations/${id}`);
  };

  useEffect(() => {
    if (!isLoggedIn) return;
    (async () => {
      try {
        const response = await fetch('/api/quotations', { credentials: 'include' });
        if (!response.ok) throw new Error('저장 견적 목록을 불러오지 못했습니다.');
        const data = await response.json();
        setQuotes(data.quotations || []);
        const id = detailId() || data.quotations?.[0]?.quotation_id;
        if (id) await openQuote(id);
      } catch (e) { setError(e.message); }
    })();
  }, [isLoggedIn]);

  if (isLoading) return <State>로그인 확인 중…</State>;
  if (!isLoggedIn) return <Login />;
  return <Shell>
    <Header><Brand><span>ANTS</span> ESTIMATE</Brand><Back href="/">← 새 견적 만들기</Back></Header>
    <Layout>
      <Panel><PanelTitle>저장 견적 <Count>{quotes.length}건</Count></PanelTitle>
        {quotes.map(q => <QuoteRow key={q.quotation_id} $active={selected?.quotation_id===q.quotation_id} onClick={()=>openQuote(q.quotation_id).catch(e=>setError(e.message))}>
          <RowTitle>#{q.quotation_id} {q.title}</RowTitle>
          <Muted><span>{q.client_name || '고객 미지정'} · {q.item_count}개 항목</span><span>{money(q.total)}</span></Muted>
        </QuoteRow>)}
      </Panel>
      <Panel>{error ? <State>{error}</State> : !selected ? <State>견적서를 선택해 주세요.</State> : <Detail>
        <Hero><div><H1>견적서 #{selected.quotation_id}</H1><div>{selected.title}</div><Muted style={{marginTop:10}}><span>고객사 {selected.client_name || '-'}</span><span>유효기간 {selected.valid_until?.slice(0,10) || '-'}</span></Muted></div><Badge>{selected.status==='completed'?'작성 완료':'작성 중'}</Badge></Hero>
        <ItemsHead><span>선택 항목</span><Count>{selected.items?.length || 0}개 모두 선택됨</Count></ItemsHead>
        {(selected.items || []).map((item, i) => <Item key={item.id || i}><Check>✓</Check><ItemName>{item.name}<small>{item.description || `${item.quantity} × ${money(item.unitPrice)}`}</small></ItemName><Price>{money(item.amount ?? item.quantity * item.unitPrice)}</Price></Item>)}
        <Totals><div><span>공급가액</span><span>{money(selected.subtotal)}</span></div><div><span>부가세</span><span>{money(selected.tax)}</span></div><div><strong>총 견적금액</strong><strong>{money(selected.total)}</strong></div></Totals>
      </Detail>}</Panel>
    </Layout>
  </Shell>;
}
